export default __webpack_public_path__ + "static/media/dash.ff9483ce.svg";